
import { Component, Prop, Vue } from 'vue-property-decorator';
import CloseIcon from 'vue-material-design-icons/Close.vue';
import PlusIcon from 'vue-material-design-icons/Plus.vue';
import BaseButtonIcon from '@/components/base/BaseButtonIcon.vue';
import CreateList from '@/components/CreateList.vue';
import AppAvatar from '@/components/AppAvatar.vue';

@Component({
    name: 'AppMenuCreate',
    components: { AppAvatar, BaseButtonIcon, CloseIcon, CreateList, PlusIcon },
})
export default class AppMenuCreate extends Vue {
    @Prop(Boolean) readonly collapsed: boolean | undefined;
    private isOpen = false;

    get disabled(): boolean {
        return !!this.$route.matched.find((route) => route.name === 'create');
    }

    private close() {
        this.isOpen = false;
    }

    private open() {
        if (this.disabled) {
            return;
        }
        this.isOpen = true;
    }
}
